module.exports = __webpack_public_path__ + "youhui3.png?8f02c32e9ed7b45fff1e0a46fb064628";


//////////////////
// WEBPACK FOOTER
// ./static/assets/youhui3.png
// module id = 188
// module chunks = 0